export enum ContractStatusEnum {
    ACTIVE = "Active",
    INACTIVE = 'Inactive',
    EXPIRED = "Expired"
}
